<div class="alert alert-danger alert-dismissible fade show mx-2" role="alert" *ngIf = "show">
  <span>{{result}}</span>
</div>
